import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '../../../../_common/functions'
import DataSelection from '../../../CreateExperiment/setScope/_components/uploadData/dataSelection'
import Button from '../../../../elements/button'
import DataFileUploader from '../../../../components/DataFileUploader'
import { UploadStatusType } from '../../../../_config/types'
import ProcessData from '../../../Measurement/Data/_components/processData/ProcessData'
import MeasurementConfigure from '../../../Measurement/MeasurementConfigure'
import ModalCloseIconButton from '../../../../components/modalCloseIconButton'

interface ScheduleExperimentModalProps {
    mode: 'create' | 'edit'
    type: 'manual' | 'auto'
    onClose: (reload: boolean) => void
    experiment: any
    createRecurringExperiment?: (payload: any) => void
}
const RecurringDataSelectionModal: React.FC<ScheduleExperimentModalProps> = ({ mode, type, onClose, experiment, createRecurringExperiment }) => {
    const { t } = useTranslation()
    const [modalOpen, setModalOpen] = useState<boolean>(false)
    const [selectedDataTable, setSelectedDataTable] = useState<any>(null)
    const [isFileChanged, setIsFileChanged] = useState<boolean>(false)
    const [FileUploader, setFileUploader] = useState<UploadStatusType>('ready-for-upload')
    const [step, setStep] = useState<'data' | 'filter' | 'config'>('data')
    const [recurringConfig, setRecurringConfig] = useState<any>(null)
    const [dataQualityReport, setDataQualityReport] = useState<any>(null)
    const [ApplyOnExpLiteral, setApplyOnExpLiteral] = useState<any>(null)
    const dataSelectionRef: any = useRef()

    console.log(isFileChanged, FileUploader)

    const onFileUploadSuccess = (data: any) => {
        trackEvent('my_experiments_recurring_data_file_uploaded', { experiment_literal: experiment?.experiment_literal, table_name: data.tableName })
        setSelectedDataTable(data.tableName)
        setDataQualityReport(data.data_quality_report)
        setApplyOnExpLiteral(data.apply_on_exp_literal)
        console.log('onFileUploadSuccess', data)
    }

    const reset = () => {
        setModalOpen(false)
        setSelectedDataTable(null)
        setIsFileChanged(false)
        setFileUploader('ready-for-upload')
    }

    useEffect(() => {
        if (experiment) {
            console.log('experiment in schedule modal', experiment)
            trackEvent('my_experiments_recurring_data_modal_opened', { experiment_literal: experiment?.experiment_literal, mode, type })
            setModalOpen(true)
        } else {
            reset()
        }
    }, [experiment])

    if (!modalOpen) return null

    return (
        <dialog className={`modal ${modalOpen ? 'modal-open' : ''}`}>
            <div
                className="modal-box remove-scroll transition-all duration-300  border-0 p-0 pb-4 rounded-[0.833rem] w-xl max-w-3xl flex flex-col overscroll-behavior-y-none relative"
                style={{
                    width: step == 'data' ? '30rem' : '70rem',
                    maxWidth: step == 'data' ? '30rem' : '70rem',
                }}
            >
                <ModalCloseIconButton
                    className="!right-0 !top-0"
                    onClick={() => {
                        trackEvent('my_experiments_recurring_data_modal_closed', { experiment_literal: experiment?.experiment_literal || experiment?.id })
                        onClose(false)
                    }}
                />

                <div className="p-4">
                    {step == 'data' && (
                        <>
                            {type == 'manual' ? (
                                <DataFileUploader
                                    onFileUploadSuccess={onFileUploadSuccess}
                                    recurringSelection={true}
                                    forChilds={experiment.children}
                                    isFileChanged={setIsFileChanged}
                                    uploadType="recurring_measurement"
                                    literal={experiment.experiment_literal || experiment?.id}
                                    uploadingStatus={setFileUploader}
                                    experimentData={experiment}
                                />
                            ) : (
                                <DataSelection
                                    recurringSelection={true}
                                    _ref={dataSelectionRef}
                                    _for="measurement"
                                    experimentData={experiment}
                                    selectedDataTable={(table: any) => {
                                        trackEvent('my_experiments_recurring_data_table_selected', { experiment_literal: experiment?.experiment_literal || experiment?.id, table_name: table?.table?.name })
                                        setSelectedDataTable(table)
                                    }}
                                />
                            )}

                            <div className="py-4 flex justify-end gap-3">
                                <Button
                                    theme="secondary"
                                    styleType="outline"
                                    size="xs"
                                    onClick={() => {
                                        trackEvent('my_experiments_recurring_data_modal_closed', { experiment_literal: experiment?.experiment_literal || experiment?.id })
                                        onClose(false)
                                    }}
                                >
                                    {t('Cancel')}
                                </Button>
                                <Button
                                    theme="secondary"
                                    size="xs"
                                    className="text-white"
                                    disabled={selectedDataTable == null}
                                    onClick={() => {
                                        trackEvent('my_experiments_recurring_data_next_step_clicked', { experiment_literal: experiment?.experiment_literal || experiment?.id })
                                        setStep('filter')
                                    }}
                                >
                                    {t('NEXT STEP')}
                                </Button>
                            </div>
                        </>
                    )}
                    {step == 'filter' && (
                        <div>
                            <ProcessData
                                data-testid="filter-tab"
                                dataType={'recurring'}
                                filterKey={'measurement_table_filters'}
                                conversionFlow={false}
                                literal={experiment?.experiment_literal || experiment?.id}
                                experimentLiteral={experiment?.experiment_literal || experiment?.id}
                                type={type}
                                selectedDataTable={selectedDataTable}
                                onRecurringFilter={(data: any) => {
                                    trackEvent('my_experiments_recurring_data_filter_applied', { experiment_literal: experiment?.experiment_literal || experiment?.id, filter: data })
                                    if (type == 'manual') {
                                        data.measurement_data_quality_report = dataQualityReport
                                    }
                                    if (ApplyOnExpLiteral) {
                                        data.apply_on_exp_literal = ApplyOnExpLiteral
                                    }
                                    setRecurringConfig(data)
                                    setStep('config')
                                }}
                                next={() => {}}
                                prev={() => {
                                    trackEvent('my_experiments_recurring_data_previous_step_clicked', { experiment_literal: experiment?.experiment_literal || experiment?.id, from_step: 'filter' })
                                    setStep('data')
                                }}
                                _for={experiment?.experiment_type?.title}
                            />
                        </div>
                    )}

                    {step == 'config' && (
                        <div>
                            <MeasurementConfigure
                                createRecurringExperiment={createRecurringExperiment}
                                recurringConfig={recurringConfig}
                                recurring_experiment={experiment}
                                prev={() => {
                                    trackEvent('my_experiments_recurring_data_previous_step_clicked', { experiment_literal: experiment?.experiment_literal || experiment?.id, from_step: 'config' })
                                    setStep('filter')
                                }}
                                type={experiment?.experiment_type?.title == 'Observational Study' ? 'OSTUDY' : 'RCT'}
                            />
                        </div>
                    )}
                </div>
            </div>

            <div className="modal-backdrop pointer-events-none"></div>
        </dialog>
    )
}

export default RecurringDataSelectionModal
